import { Messages, Resources } from './Tabs';

export default { messages: Messages, resources: Resources };
